import { selectors as marketSelectors } from '@clearscore-group/lib.redux.market';

const interpolateWithMarket = ({ state, url = '', market = null }) =>
    url.replace(/@market@/gi, market || marketSelectors.getActiveMarket(state) || 'global');

export default interpolateWithMarket;
